import Link from "next/link";
import { ComponentProps } from "react";

import { cn } from "@/utils/cn";

export default function HeaderItem({
  className,
  ...props
}: ComponentProps<typeof Link>) {
  return (
    <Link
      className={cn(
        "h-fit rounded-md px-4 py-4 text-sm leading-none text-gray hover:bg-gray/5 header:py-2 header:text-base",
        className,
      )}
      {...props}
    />
  );
}
